module.exports = __webpack_public_path__ + "static/media/cs2.ccc8da5c.jpg";